import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axiosInstance';

const t = (name, fn) =>
  createAsyncThunk(name, async (arg, { rejectWithValue }) => {
    try { return await fn(arg); }
    catch (err) { return rejectWithValue(err.message); }
  });

export const fetchNotifications = t('notification/fetchAll', async (params = {}) => {
  const { data } = await api.get('Notifications', { params });
  return data.data;
});

export const markNotificationRead = t('notification/markRead', async (id) => {
  await api.patch(`Notifications/${id}/read`);
  return id;
});

export const markAllRead = t('notification/markAllRead', async () => {
  await api.patch('Notifications/read-all');
  return true;
});

// Called from SignalR hub when new notification arrives
const notificationSlice = createSlice({
  name: 'notification',
  initialState: { items: [], totalCount: 0, unreadCount: 0, loading: false },
  reducers: {
    addRealtime: (state, action) => {
      state.items = [action.payload, ...state.items];
      state.unreadCount += 1;
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (s) => { s.loading = true; })
      .addCase(fetchNotifications.fulfilled, (s, a) => {
        s.loading = false;
        s.items = a.payload?.items || [];
        s.totalCount = a.payload?.totalCount || 0;
        s.unreadCount = s.items.filter((n) => !n.isRead).length;
      })
      .addCase(fetchNotifications.rejected, (s) => { s.loading = false; })
      .addCase(markNotificationRead.fulfilled, (s, a) => {
        s.items = s.items.map((n) =>
          n.notificationId === a.payload ? { ...n, isRead: true } : n
        );
        s.unreadCount = Math.max(0, s.unreadCount - 1);
      })
      .addCase(markAllRead.fulfilled, (s) => {
        s.items = s.items.map((n) => ({ ...n, isRead: true }));
        s.unreadCount = 0;
      });
  },
});

export const { addRealtime, setUnreadCount } = notificationSlice.actions;
export default notificationSlice.reducer;